import { useContext } from 'react';
import { Experiments } from '../types';

import ExperimentsContext from '../state/ExperimentsContext';

/**
 * Return all experiments by key -> value
 */
const useAllExperiments = (): Experiments => {
  const flags = useContext(ExperimentsContext);
  return flags?.experiments ?? {};
};

export default useAllExperiments;
